import ChevronUpIconPath from "@ingka/ssr-icon/paths/chevron-up";

export default ChevronUpIconPath;
